module.exports = __webpack_public_path__ + "static/img/vr8.8fef6a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr8.png
// module id = TFvA
// module chunks = 1